'use client';

import classes from './DarkGreenButton.module.css';

const DarkGreenButton = ({
	className = '',
	onClick = () => {},
	type = 'submit',
	value = '',
	name = '',
	children,
}) => {
	return (
		<button
			className={`${classes.Button} ${className}`}
			onClick={onClick}
			type={type}
			value={value}
			name={name}
		>
			<div className={classes.text}> {children} </div>
		</button>
	);
};

export default DarkGreenButton;
